<script>
export default {
  methods: {
    alertDisplay (message, type) {
      this.$buefy.snackbar.open({
        duration: 15000,
        message,
        position: 'is-top',
        type
      })
    },
    alertDisplayFailure (message) {
      this.alertDisplay(message, 'is-danger')
    },
    alertDisplaySuccess (message) {
      this.alertDisplay(message, 'is-success')
    }
  }
}
</script>
